import CustomNode from './CustomNode';

export const nodeTypes = { default: CustomNode, input: CustomNode, output: CustomNode } as const;

export default nodeTypes;

